"use client";

import {useEffect, useRef} from "react";
import {onAuthStateChanged} from "firebase/auth";
import {signIn, signOut} from "next-auth/react";
import {auth} from "@/lib/firebaseConfig";

export default function useFirebaseOnAuthStateChanged() {
  // Use a ref to hold the latest token to avoid unnecessary signIn calls.
  const currentIdTokenRef = useRef<string | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log("onAuthStateChanged");
      if (user) {
        console.log("onAuthStateChanged user");
        try {
          // Get the fresh Firebase ID token.
          const idToken = await user.getIdToken(true);

          // Only update the NextAuth session if the token has changed.
          if (currentIdTokenRef.current !== idToken) {
            currentIdTokenRef.current = idToken;
            await signIn("firebase-credentials", {
              idToken,
              redirect: false, // Do not redirect after sign in.
              callbackUrl: window.location.href // Use the current page as the callback URL.
            });
          }
        } catch (error) {
          console.error("Error updating NextAuth session with Firebase token:", error);
        }
      } else {
        try {
          console.log("onAuthStateChanged signOut");
          if (currentIdTokenRef.current !== null) {
            try {
              currentIdTokenRef.current = null;
              await signOut({
                redirect: false,
                callbackUrl: "/"
              });
            } catch (error) {
              console.error("Error during NextAuth sign out:", error);
            }
          } else {
            console.log("Already signed out; skipping signOut call.");
          }
        } catch (error) {
          console.error("Error during NextAuth sign out:", error);
        }
      }
    });

    // Cleanup listener on unmount.
    return () => unsubscribe();
  }, []);
}
